import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

const parseSettingValue = (value) => {
  if (!value) return {};

  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return {};
    }
  }

  return value;
};

const normalizeMinimumMembershipFee = (data) => {
  const setting = data?.data?.data || data?.data || data || {};
  const value = parseSettingValue(setting?.value);

  return {
    id: setting?.id || null,
    key: setting?.key || "minimum_membership_fee",
    description: setting?.description || "",
    individualFee: Number(value?.individualFee || 500000),
    fee: Number(value?.fee || 2000000),
  };
};

export const fetchMinimumMembershipFee = createAsyncThunk(
  "settings/fetchMinimumMembershipFee",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/setting-minimum-membership-fee");

      return normalizeMinimumMembershipFee(response.data?.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  },
);

export const updateMinimumMembershipFee = createAsyncThunk(
  "settings/updateMinimumMembershipFee",
  async (dataUpdate, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(
        "/setting-minimum-membership-fee-update",
        dataUpdate,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return normalizeMinimumMembershipFee(response.data?.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  },
);

const settingSlice = createSlice({
  name: "settings",
  initialState: {
    minimumMembershipFee: {
      id: null,
      key: "minimum_membership_fee",
      description: "",
      individualFee: 500000,
      fee: 2000000,
    },
    status: "idle",
    updateStatus: "idle",
    error: null,
  },
  reducers: {
    setMinimumMembershipFee: (state, action) => {
      state.minimumMembershipFee = {
        ...state.minimumMembershipFee,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMinimumMembershipFee.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMinimumMembershipFee.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.minimumMembershipFee = action.payload;
      })
      .addCase(fetchMinimumMembershipFee.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(updateMinimumMembershipFee.pending, (state) => {
        state.updateStatus = "loading";
      })
      .addCase(updateMinimumMembershipFee.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.minimumMembershipFee = action.payload;
      })
      .addCase(updateMinimumMembershipFee.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { setMinimumMembershipFee } = settingSlice.actions;
export default settingSlice.reducer;